module.exports = __webpack_public_path__ + "static/media/ladd.675073eb.pdf";